import { render, staticRenderFns } from "./InfoTextEditor.vue?vue&type=template&id=1a2ca08a&scoped=true"
import script from "./InfoTextEditor.vue?vue&type=script&lang=js"
export * from "./InfoTextEditor.vue?vue&type=script&lang=js"
import style0 from "./InfoTextEditor.vue?vue&type=style&index=0&id=1a2ca08a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ca08a",
  null
  
)

export default component.exports